import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  maxWidth: 400,
};

export const daysContainerStyle: SxProps<Theme> = (theme) => ({
  bgcolor: theme.palette.modalColors.bgBlockColor,
  p: 2,
  borderRadius: "18px",
  display: "flex",
  flexWrap: "wrap",
  gap: 2,
  mb: 2,
});

export const badgeStyle: SxProps<Theme> = (theme) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#06B6D4",
    color: "#fff",
    border: `3px solid #fff`,
    minWidth: "24px",
    height: "24px",
    padding: "0 6px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.7rem",
    fontWeight: 600,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  },
});

export const dayButtonStyle = (
  isSelected: boolean,
  theme: Theme,
): SxProps<Theme> => ({
  borderRadius: "12px",
  textTransform: "uppercase",
  ...(isSelected
    ? {
        backgroundColor: "#06B6D4",
        borderColor: "#06B6D4",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#06B6D4",
        },
      }
    : {
        borderColor: theme.palette.modalColors.separatorColor,
        color: theme.palette.header.userBlock.nameColor,
        "&:hover": {
          borderColor: theme.palette.modalColors.separatorColor,
        },
      }),
});

export const dayCardStyle: SxProps<Theme> = {
  p: 2,
  backgroundColor: "#06B6D4",
  borderRadius: "16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const dayTitleStyle: SxProps<Theme> = {
  fontWeight: 600,
  color: "#fff",
  textAlign: "left",
  mb: 2,
};

export const hoursOuterContainerStyle: SxProps<Theme> = {
  position: "relative",
  width: "220px",
  borderRadius: "12px",
  overflow: "hidden",
};

export const hoursInnerContainerStyle: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.modalColors.bgBlockColor,
  borderRadius: "12px",
  p: 2,
  maxHeight: "220px",
  overflowY: "auto",
  color: "#000",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: theme.palette.modalColors.bgBlockColor,
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#06B6D4",
    borderRadius: "4px",
    border: "1px solid #FFFFFF",
  },
  scrollbarWidth: "thin",
  scrollbarColor: `#06B6D4 ${theme.palette.modalColors.bgBlockColor}`,
});

export const hourRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  mb: 1,
};

export const hourBoxStyle = (isSelected: boolean): SxProps<Theme> => ({
  width: 24,
  height: 24,
  minWidth: 24,
  borderRadius: "6px",
  border: `2px solid ${isSelected ? "#06B6D4" : "#E6E6E6"}`,
  backgroundColor: isSelected ? "#06B6D4" : "transparent",
  cursor: "pointer",
  mr: 1.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const timeSectionHeaderStyle: SxProps<Theme> = {
  display: "block",
  fontSize: "0.7rem",
  fontWeight: 600,
  color: "#06B6D4",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mt: 2,
  mb: 0.5,
  "&:first-of-type": {
    mt: 0,
  },
};

export const emptySelectionStyle: SxProps<Theme> = (theme) => ({
  color: "rgba(255,255,255,0.9)",
  fontSize: "0.875rem",
  fontStyle: "italic",
  mb: 1,
});

export const clearButtonStyle: SxProps<Theme> = () => ({
  mt: 1,
  color: "rgba(255,255,255,0.9)",
  fontSize: "0.75rem",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.1)",
    color: "#fff",
  },
});

export const hourTextStyle: SxProps<Theme> = {
  cursor: "pointer",
  color: "#06B6D4",
  fontWeight: 600,
  fontSize: "18px",
};

export const sendButtonContainerStyle: SxProps<Theme> = {
  mt: 2,
};

export const sendButtonStyle: SxProps<Theme> = (theme) => ({
  border: "2px solid #06B6D4",
  backgroundColor: theme.palette.modalColors.bgBlockColor,
  color: "#06B6D4",
  borderRadius: "24px",
  padding: "8px 16px",
  fontWeight: "bold",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#FFFFFF",
    color: "#06B6D4",
    borderColor: "#06B6D4",
  },
});
